import { AlertTriangle } from "lucide-react";
import { isFirebaseConfigured, firebaseMissingKeys } from "@/firebase/config";

/**
 * Mostrado no topo de qualquer tela pública enquanto o projeto Firebase não
 * estiver configurado (.env.local ausente/incompleto). Sem isso, chamadas ao
 * Auth/Firestore falham de forma pouco óbvia e a experiência parece "tela
 * em branco" ou botões que não fazem nada.
 */
export function FirebaseConfigWarning() {
  if (isFirebaseConfigured) return null;

  return (
    <div className="border-b border-warning/30 bg-warning/10 px-4 py-2.5 text-xs text-foreground">
      <div className="container flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-warning" />
        <p>
          <strong>Firebase não configurado.</strong> Copie <code className="rounded bg-black/5 px-1 dark:bg-white/10">.env.example</code> para{" "}
          <code className="rounded bg-black/5 px-1 dark:bg-white/10">.env.local</code>, preencha com os dados do seu projeto e reinicie{" "}
          <code className="rounded bg-black/5 px-1 dark:bg-white/10">npm run dev</code>. Faltando: {firebaseMissingKeys.join(", ")}.
        </p>
      </div>
    </div>
  );
}
